<div class="feFicheEntrepriseModal feModal">
    <div class="feModalHeader">
        <div class="leftPart">
            <div class="firstTitleLine">
                aaaaaaaaaaaaaaa
<!--                <div style="flex: 1; display: flex">-->
<!--                    <span class="feModalTitle" title="{{entreprise.name}}">-->
<!--                        {{entreprise.name}}-->
<!--                    </span>-->
<!--                    <div class="fe-icon" title="WebToLead" *ngIf="webToLead && webToLeadCompanies.includes(companyId)"-->
<!--                         style="margin-right: auto;">-->
<!--                        <img alt="webtolead" (click)="exportEnterpriseWebToLead()" class="svgBlue"-->
<!--                             src="assets/icon/fe-icons/web_to_lead.svg"/>-->
<!--                    </div>-->
<!--                </div>-->


<!--                <div class="fe-icon" *ngIf="entreprise.linkedin != null">-->
<!--                    <img alt="linkedin" (click)="openUrl(entreprise.linkedin)" class="svgBlue"-->
<!--                         src="assets/icon/fe-icons/linkedin.svg"/>-->
<!--                </div>-->
<!--                <div class="fe-icon" *ngIf="entreprise.facebook != null">-->
<!--                    <img alt="facebook" (click)="openUrl(entreprise.facebook)" class="svgBlue"-->
<!--                         src="assets/icon/fe-icons/facebook.svg"/>-->
<!--                </div>-->
<!--                <div class="fe-icon" *ngIf="entreprise.twitter != null">-->
<!--                    <img alt="twitter" (click)="openUrl(entreprise.twitter)" class="svgBlue"-->
<!--                         src="assets/icon/fe-icons/twitter.svg"/>-->
<!--                </div>-->
<!--            </div>-->

<!--            <div class="secondTitleLine">-->
<!--                <span class="addressLine littleText">-->
<!--                    {{entreprise.cp}} {{entreprise.ville}}-->
<!--                </span>-->
<!--                <div class="websiteLine" *ngIf="entreprise.website != null">-->
<!--                    <mat-icon>language</mat-icon>-->
<!--                    <a target="_blank" href="{{entreprise.website}}" (click)="logWebsiteClick()" >{{entreprise.website}}</a>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->

<!--        &lt;!&ndash;        TODO REMETTRE Ca quand le scroll fonctionnera correctement&ndash;&gt;-->
<!--        <div class="rightPart">-->
<!--            <div class="anchorBtn" [class.selectedAnchor]="visibleElementIndex === 0"-->
<!--                 (click)="scrollToSection('infosJuridiquesBloc')">Infos juridiques</div>-->
<!--            <div class="anchorBtn" [class.selectedAnchor]="visibleElementIndex === 1"-->
<!--                 (click)="scrollToSection('contactsBloc')">Contacts</div>-->
<!--            <div class="anchorBtn" [class.selectedAnchor]="visibleElementIndex === 2"-->
<!--                 (click)="scrollToSection('signauxBloc')">Signaux</div>-->
<!--            <div class="anchorBtn" [class.selectedAnchor]="visibleElementIndex === 3"-->
<!--                 (click)="scrollToSection('etablissementsBloc')">Etablissements</div>-->
<!--        </div>-->

<!--        <div class="feModalCloseButton">-->
<!--            <mat-icon (click)="close()">close</mat-icon>-->
<!--        </div>-->
    </div>
</div>